import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { useContrastedBackground } from 'app/frontend/base/components/Card'

interface Props {
  character?: wowaudit.Character
}

const ProfessionsSummary = ({ character }: Props) => {
  const { t } = useTranslation()
  const background = useContrastedBackground()
  const professions = character?.details?.professions
  if (!professions) return null

  if (!professions.length) {
    return (
      <p className='italic opacity-70'>
        {t('dashboard.character.professions-empty')}
      </p>
    )
  }

  return (
    <ul>
      {professions.map((profession) => (
        <li
          key={profession.skillLineId}
          className={cn(
            background,
            'border my-1 py-3 px-4 rounded-md flex items-center justify-between gap-4',
          )}
        >
          <span>{profession.name}</span>
          <span className='flex items-baseline gap-1'>
            <span
              className={`text-2xl font-medium leading-none tracking-tight ${
                profession.rank >= profession.maxRank
                  ? 'text-success-foreground'
                  : ''
              }`}
            >
              {profession.rank}
            </span>
            <span className='text-sm text-muted-foreground'>
              / {profession.maxRank}
            </span>
          </span>
        </li>
      ))}
    </ul>
  )
}

export default ProfessionsSummary
